// extracted by mini-css-extract-plugin
export default {"header":"Home_header__P24UF","content":"Home_content__cNJqH","createButton":"Home_createButton__JtiZh","aboutSection":"Home_aboutSection__ztR4e"};